import React from 'react';

function PaginationLeft2Icon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.85355 4.64645C10.0488 4.84171 10.0488 5.15829 9.85355 5.35355L5.20711 10L9.85355 14.6464C10.0488 14.8417 10.0488 15.1583 9.85355 15.3536C9.65829 15.5488 9.34171 15.5488 9.14645 15.3536L4.14645 10.3536C3.95118 10.1583 3.95118 9.84171 4.14645 9.64645L9.14645 4.64645C9.34171 4.45118 9.65829 4.45118 9.85355 4.64645ZM15.8536 4.64645C16.0488 4.84171 16.0488 5.15829 15.8536 5.35355L11.2071 10L15.8536 14.6464C16.0488 14.8417 16.0488 15.1583 15.8536 15.3536C15.6583 15.5488 15.3417 15.5488 15.1464 15.3536L10.1464 10.3536C9.95118 10.1583 9.95118 9.84171 10.1464 9.64645L15.1464 4.64645C15.3417 4.45118 15.6583 4.45118 15.8536 4.64645Z"
        fill="#121212"
      />
    </svg>
  );
}

export default PaginationLeft2Icon;
